export default __webpack_public_path__ + "static/media/service5.62a8e6e6.png";